import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Column, Divider, Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import ClickableNetworkImages from "../../common/components/image/ClickableNetworkImages";
import { C1Text } from "../../common/components/text/CustomText";
import CustomTab from "../../common/components/tab/CustomTab";
import { useParams, useSearchParams } from "react-router-dom";
import DeviceTabContent from "./tabs/DeviceTabContent";
import ReportTabContent from "./tabs/ReportTabContent";
import QRCodeTabContent from "./tabs/QRCodeTabContent";
import Translate from "../../common/translate/Translate";
import { useEffect, useState } from "react";
import StoreService from "../../service/StoreService";
import PGCodeTabContent from "./tabs/PGCodeTabContent";
import StoreEditModal from "./modals/StoreEditModal";
import DividerTextRow from "../../common/components/text/DividerTextRow";

const defaultShopImages = [
    { src: "https://picsum.photos/id/100/200/300", alt: "Image 1" },
    { src: "https://picsum.photos/id/101/200/300", alt: "Image 1" },
    { src: "https://picsum.photos/id/102/200/300", alt: "Image 1" },
    { src: "https://picsum.photos/id/103/200/300", alt: "Image 1" },
    { src: "https://picsum.photos/id/104/200/300", alt: "Image 1" },
];

const tabs = [
    { value: "Device", label: Translate("store.tabs.device") },
    { value: "Report", label: Translate("store.tabs.report") },
    { value: "QRCode", label: Translate("store.tabs.qrCode") },
    { value: "PGCode", label: "PG Code" },
];

function StoreDetailPage() {
    const { id: storeId } = useParams();
    const service = new StoreService();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "Device";

    const handleSetTab = (tabValue) => {
        setSearchParams({ tab: tabValue }, { replace: true });
    };

    // store detail data
    const [storeInfo, setStoreInfo] = useState(null);
    const [shopImages, setShopImages] = useState(defaultShopImages);

    const fetchStoreDetail = () => {
        if (!storeId) return;
        // 매장 별 기기 상태 조회 (04.01.11.01) — 기존 /stores/report-detail 대신 /status/<store-id> 호출
        // TODO: 응답(result.status: 기기별 상태 목록)을 표시할 UI 소비처 미정. 확정 시 state로 연결.
        service
            .getStoreDeviceStatus({ storeId })
            .then((result) => {
                console.debug("store device status:", result);
            })
            .catch((error) => {
                console.error("Error fetching store device status:", error);
            });
        service
            .getStoreDetail({ storeId })
            .then((result) => {
                setStoreInfo(result);
                if (result.images && result.images.length > 0) {
                    setShopImages(result.images.map((img) => ({ src: img.url, alt: img.alternativeText })));
                } else {
                    setShopImages([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching store info:", error);
            });
    };

    useEffect(() => {
        fetchStoreDetail();
    }, [storeId]);

    // save modal state
    const [openEditModal, setOpenEditModal] = useState(false);

    return (
        <CommonContentWrapper>
            <Padding padding={"24px 20px"}>
                <PageTitle title={storeInfo?.storeName || "Store Detail"} hasHistoryBack={true} />
                <SizedBox height={"24px"} />
                <Row width={"auto"} maxWidth={"100%"}>
                    {shopImages.length === 0 && <SizedBox width={"128px"} height={"72px"}></SizedBox>}
                    {shopImages.length > 0 && (
                        <ClickableNetworkImages
                            images={shopImages}
                            width={"128px"}
                            height={"72px"}
                            borderRadius={"12px"}
                        />
                    )}
                    <Column flex={"1"} justifyContent={"flex-start"} alignItem={"flex-start"} padding={"0 0 0 20px"}>
                        <C1Text>{storeInfo?.storeName || "Store"}</C1Text>
                        <SizedBox height={"8px"} />
                        <Row width={"100%"}>
                            <DividerTextRow
                                items={[
                                    { icon: "shop", value: storeInfo?.shopCode || "-" },
                                    {
                                        icon: "user",
                                        value: storeInfo?.businessInfo?.ownerName || "-",
                                    },
                                    {
                                        icon: "phone",
                                        value: storeInfo?.phone || "-",
                                    },
                                    {
                                        icon: "location_mark",
                                        value:
                                            [
                                                storeInfo?.address?.address1,
                                                storeInfo?.address?.city,
                                                storeInfo?.address?.states,
                                            ]
                                                .filter(Boolean)
                                                .join(", ") || "-",
                                    },
                                    { icon: "mail", value: storeInfo?.email || "-" },
                                    // {
                                    //     icon: "shop_coin",
                                    //     value:
                                    //         storeInfo?.storeType === 0
                                    //             ? "Basic"
                                    //             : storeInfo?.storeType === 1
                                    //                 ? "OPL"
                                    //                 : "-",
                                    // },
                                ]}
                            />
                            {/*<Row flex={"1"} justifyContent={"flex-end"}>*/}
                            {/*    <SecondaryButton icon={"edit"} text={"Edit"} onClick={() => setOpenEditModal(true)} />*/}
                            {/*</Row>*/}
                        </Row>
                    </Column>
                </Row>
            </Padding>
            <Divider />
            <Padding padding={"24px 20px"}>
                <CustomTab tabs={tabs} activeTab={activeTab} onClick={handleSetTab} />
                {activeTab === "Device" && <DeviceTabContent shopCode={storeId} />}
                {activeTab === "Report" && <ReportTabContent storeId={storeId} />}
                {activeTab === "QRCode" && (
                    <QRCodeTabContent storeId={storeId} storeName={storeInfo?.storeName} />
                )}
                {activeTab === "PGCode" && <PGCodeTabContent storeId={storeInfo?.storeId} />}
            </Padding>
            {openEditModal && (
                <StoreEditModal
                    isOpen={openEditModal}
                    onClose={() => setOpenEditModal(false)}
                    storeId={storeId}
                    storeDetail={storeInfo}
                    onSave={fetchStoreDetail}
                ></StoreEditModal>
            )}
        </CommonContentWrapper>
    );
}

export default StoreDetailPage;
